import {
  watchSubmitSignupStep,
  watchUserAuth,
  watchSetNotificationRead,
  watchGetProfileSettingsInfo,
  watchGetNotifications,
  watchUpdateProfileSettingsInfo,
  watchGetUserInfo,
  watchResendByEmail,
} from 'store/user/saga';

export default [
  watchSubmitSignupStep,
  watchUserAuth,
  watchSetNotificationRead,
  watchGetProfileSettingsInfo,
  watchGetNotifications,
  watchUpdateProfileSettingsInfo,
  watchGetUserInfo,
  watchResendByEmail,
];
